import React from 'react';

import { MessageBubble } from '../MessageBubble';
import styles from './reaction-comment.module.scss';
import {
  FormBody,
  FormError,
  Heading_3,
  Loader,
  useThemeContext,
} from '@huggg/react-components';

export const ReactionComment = ({
  onConfirm,
  loading = false,
  value = '',
  error = '',
}) => {
  const {
    reaction: {
      copy: { comment },
    },
  } = useThemeContext();

  const renderValue = () => {
    return (
      <div className={styles.bubble}>
        <MessageBubble animate={false} fromSelf message={value} />
      </div>
    );
  };

  const renderForm = () => (
    <div className={styles.border}>
      <Heading_3>{comment.heading}</Heading_3>
      <div className={styles.form}>
        <FormBody
          model={[
            {
              name: 'message',
              elementType: 'textarea',
              placeholder: comment.labels.message,
              placeholderAttribute: comment.placeholders.message,
              optional: true,
              displayOptional: true,
            },
            {
              name: 'name',
              elementType: 'string',
              placeholder: comment.labels.name,
              optional: true,
              displayOptional: true,
            },
          ]}
          initialValues={{
            message: '',
            name: '',
          }}
          buttonCopy={comment.button}
          onConfirm={({ message = '', name = '' }) => {
            onConfirm(`${message}`, `${name}`);
          }}
        />
        <FormError className={styles.error}>{error}</FormError>
      </div>
    </div>
  );

  if (loading) {
    return (
      <div className={styles.container}>
        <Loader />
      </div>
    );
  }

  return (
    <div className={styles.container}>
      {value ? renderValue() : renderForm()}
    </div>
  );
};
